export default __webpack_public_path__ + "static/SRI 4700PW - Product Specifications & Technical Data-27039fe3978cc5f3aa244c47797bfc7d.pdf";